<template>

  <div>
    <div class="window-header">
      <h3 class="title">Empresa: {{ enterprise }}</h3>
      <button class="button-close"
        @click="$modal.hide('investment-detail')">×
      </button>
    </div>
    <tabs :options="{ defaulTabHash: 'first-tab'}">
      <tab id="first-tab" name="Detalle de inversión">
        <EnterpriseDetails :investmentDetail="investmentDetail"/>
      </tab>
      <tab id="second-tab" name="Fechas compromiso de pago">
        <UpcomingPayments
          :investmentUpcomingPayments="investmentUpcomingPayments"/>
      </tab>
    </tabs>
  </div>

</template>

<script>
import EnterpriseDetails from '@/views/dashboardInvestment/EnterpriseDetails'
import UpcomingPayments from '@/views/dashboardInvestment/UpcomingPayments'

import { Tabs, Tab } from 'vue-tabs-component'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'DashboardInvestmentDetail',
  components: {
    Tab,
    Tabs,
    EnterpriseDetails,
    UpcomingPayments
  },
  mixins: [httpRequestMixin],
  props: {
    frId: {
      type: Number,
      required: true
    },
    investmentId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      investmentDetail: {},
      investmentUpcomingPayments: {},
      enterprise: null
    }
  },
  created: function () {
    this.getInvestmentDetail()
    this.getInvestmentUpcomingPayments()
  },
  methods: {
    getInvestmentDetail: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + `/investments/${this.investmentId}/`,
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.investmentDetail = response.data
          this.enterprise = response.data.business_name
        }
      }
    },
    getInvestmentUpcomingPayments: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + `/fr-payments/`,
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          fr: this.frId,
          limit: 1
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.investmentUpcomingPayments = response.data
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.box-detail-investment {

  .box-company-logo {
    margin-top: 1rem;

    .icon {
       margin: 1.5rem 1.1rem 0!important;
    }

    &.nologo {
      background-color: $midnight-blue;

      .icon {
        width: 110px;
        height: 80px;
      }
    }
  }
}

.tabs-component {
  margin: 0;
}

.tabs-component-panels {
  border-top-left-radius: 0;
  background-color: $white;
  border: solid 1px #ddd;
  border-radius: 0 6px 6px 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .05);
  padding: 2rem 2rem;
}

</style>



// WEBPACK FOOTER //
// src/views/dashboardInvestment/DashboardInvestmentDetail.vue